module.exports = __webpack_public_path__ + "img/na.ffa20ac0.png";